import { FeatureHelperService } from './../../_helpers/feature-helper/feature-helper.service';
import { TutorReportsHelperService } from '../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { PlacementService, ActionService } from "../../_services/index";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../_helpers/custom-validators';

import { Baseline, ControlData, PlacementData } from '../../_models/tutor-reports/tutorreport';
import { MatDialog } from '@angular/material/dialog';
import { SubmissionHistoryRecords } from '../../shared/submission-history-records';
import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';
import { forkJoin, Observable, of, Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DropdownDialogComponent } from '../../shared/dropdown-list-dialog';
import { BaseComponent } from '../../base.component';
import { MediaChange } from '@ngbracket/ngx-layout';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { LearningBandTableModalComponent } from '../learning-band-table-modal/learning-band-table-modal.component';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';

@Component({
    templateUrl: 'tutor-reports.baseline.component.html',
    selector: 'tutorreports-baseline',
    styleUrls: ['./tutor-reports.baseline.component.css'],
    standalone: false
})

export class TutorReportsBaselineComponent extends BaseComponent implements OnInit, OnDestroy {
  public placementData: PlacementData;
  private unsubscribe: Subject<void> = new Subject<void>();

  // @Input() commondata: CommonData;
  // @Input() placementData: PlacementData;
  // placementId: number;
  @Input() groupStudentId?: number;
  @Input() studentIdForLinkAssessment: number;

  @Output() onDataSaved: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusUpdated: EventEmitter<string> = new EventEmitter<string>();

  model: any = {};
  errors: any = {};
  submissionData: any = {};
  public loading = false;
  enableBtnResend: boolean = false;
  activationCode: string;
  frmBaseline: UntypedFormGroup;
  submitted = false;
  returnUrl: string;
  mindate: Date = new Date(new Date().setDate(new Date().getDate() - 180));
  maxdate: Date = new Date(new Date().setDate(new Date().getDate() + 1));
  public current: number = 0;
  controlData: ControlData = null;
  actionItem: any = {};
  grades: any = [];
  keyStages: any = [];
  enableValidation: boolean = false;
  watcher: Subscription;

  public hasStaffSavePermissions: boolean = false;
  public hasManagerSavePermissions: boolean = false;
  public hasEditPermissions: boolean = false;

  public hasApprovePermissions: boolean = false;
  public hasRejectPermissions: boolean = false;
  public hasUnlockPermission: boolean = false;

  public baselineStatus: string = 'New';

  public isMobile: boolean = (window.innerWidth) <= 897;
  @HostListener('window:resize')
  checkingForMobileSize() {
    this.isMobile = (window.innerWidth) <= 897;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    private placementService: PlacementService,
    private actionService: ActionService,
    public dialog: MatDialog,
    private successModalHelper: SuccessModalHelperService,
    private featureHelperService: FeatureHelperService,
    public tutorReportsHelperService: TutorReportsHelperService,
    public themeService: ThemeService,
    private errorModalHelper: ErrorModalHelperService,
  ) {
    super();
    this.watcher = this.media.asObservable().subscribe((changes: MediaChange[]) => { const change = changes[0]; if (!change) return;

      this.loadContent(change.mqAlias);
    });

    this.tutorReportsHelperService.placementData$
      .pipe(
        filter((d): d is PlacementData => d != null),
        takeUntil(this.unsubscribe)
      )
      .subscribe(pd => this.placementData = pd);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  get f() { return this.frmBaseline.controls; }

  ngOnInit() {

    this.actionService.currentMessage.subscribe(message => {
      this.actionItem = message;
    });

    this.renderComponent();
  }

  public async renderComponent() {


    if (!this.model) {
      this.model = {
        baselineDate: '',
        targetLearningBand: '',
        rowId: null,
        submitted: false,
        approved: false
      };
    }

    this.mindate = new Date(this.tutorReportsHelperService.commonData.placementStartDate);
    this.maxdate = new Date(this.tutorReportsHelperService.commonData.placementEndDate);

    let minDateHolder = new Date(this.tutorReportsHelperService.commonData.placementStartDate);
    this.mindate.setDate(minDateHolder.getDate() - 30);

    let today = new Date();
    today.setHours(0, 0, 0, 0);

    if (today.valueOf() < this.maxdate.valueOf()) {
      this.maxdate = today;
    }
    if (today.valueOf() < this.mindate.valueOf()) {
      this.maxdate = this.mindate;
    }

    this.mindate.setHours(0, 0, 0, 0);
    this.maxdate.setHours(0, 0, 0, 0);

    this.frmBaseline = this.formBuilder.group({
      baselineDate: [null, Validators.compose([
        Validators.required,
        CustomValidators.DateRangeValidator('baselineDate', this.mindate, this.maxdate)
      ])],
      targetLearningBand: [null, Validators.compose([
        Validators.required, Validators.min(1)
      ])],
      individualLearningPlan: [null, Validators.compose([
        Validators.minLength(20),
        Validators.maxLength(1024),
        CustomValidators.patternValidator(/^[£\x20-\x7E]+$/, {
          //hasNumber: true
        })])],

      //targetDescription: [null,  [Validators.required, Validators.minLength(20), Validators.maxLength(1024)]],
      //tutorInitialAssessment: [null, [Validators.required, Validators.minLength(20), Validators.maxLength(1024)]],
      targetDescription: [null],
      tutorInitialAssessment: [null],
      learnerComments: [null, [Validators.maxLength(1024)]],
      rowId: [null],
      targetKeyStage: [null, Validators.compose([
        Validators.required, Validators.min(1)
      ])],
      initialLearningBand: [null, Validators.compose([
        Validators.required, Validators.min(1)
      ])],
      initialKeyStage: [null, Validators.compose([
        Validators.required, Validators.min(1)
      ])],
      assessmentScorePercentage: [null, [Validators.min(0), Validators.max(100)]],
      assessmentId: [null, null],
      assessmentDate: [null, null]
    });

    this.keyStages = this.tutorReportsHelperService.keyStages;
    this.grades = this.tutorReportsHelperService.targetGrades;

    if (this.tutorReportsHelperService.commonData.placementId != null) {

      let requiredPermissions = new Array<string>();
      requiredPermissions.push("IndividualLearningReportsSave", "TutorReportsSave", "IndividualLearningReportsEdit", "IndividualLearningReportsApprove", "IndividualLearningReportsReject", "UnlockIndividualLearningReports");
      let permissionsResult = this.featureHelperService.checkFeaturePermissions(requiredPermissions);
      this.hasStaffSavePermissions = permissionsResult.filter(p => p.feature === "IndividualLearningReportsSave")[0].enabled;
      this.hasManagerSavePermissions = permissionsResult.filter(p => p.feature === "TutorReportsSave")[0].enabled;
      this.hasEditPermissions = permissionsResult.filter(p => p.feature === "IndividualLearningReportsEdit")[0].enabled;

      this.hasApprovePermissions = permissionsResult.filter(p => p.feature === "IndividualLearningReportsApprove")[0].enabled;
      this.hasRejectPermissions = permissionsResult.filter(p => p.feature === "IndividualLearningReportsReject")[0].enabled;
      this.hasUnlockPermission = permissionsResult.filter(p => p.feature === "UnlockIndividualLearningReports")[0].enabled;

      try {
        this.tutorReportsHelperService.baseline = await this.getBaseline();
        if (this.tutorReportsHelperService.baseline !== null) {
          this.model = this.tutorReportsHelperService.baseline;
          this.frmBaseline.get('baselineDate').setValue(this.tutorReportsHelperService.baseline.baselineDate);

          this.frmBaseline.get('initialLearningBand').setValue(this.tutorReportsHelperService.baseline.initialLearningBand);
          this.frmBaseline.get('initialKeyStage').setValue(this.tutorReportsHelperService.baseline.initialKeyStage);

          this.frmBaseline.get('targetLearningBand').setValue(this.tutorReportsHelperService.baseline.targetLearningBand);
          this.frmBaseline.get('targetKeyStage').setValue(this.tutorReportsHelperService.baseline.targetKeyStage);

          this.frmBaseline.get('individualLearningPlan').setValue(this.tutorReportsHelperService.baseline.individualLearningPlan);
          this.frmBaseline.get('targetDescription').setValue(this.tutorReportsHelperService.baseline.targetDescription);
          this.frmBaseline.get('tutorInitialAssessment').setValue(this.tutorReportsHelperService.baseline.tutorInitialAssessment);
          this.frmBaseline.get('learnerComments').setValue(this.tutorReportsHelperService.baseline.learnerComments);
          this.frmBaseline.get('rowId').setValue(this.tutorReportsHelperService.baseline.rowId);
          this.frmBaseline.get('assessmentScorePercentage').setValue(this.tutorReportsHelperService.baseline.assessmentScorePercentage);
          this.frmBaseline.get('assessmentId').setValue(this.tutorReportsHelperService.baseline.assessmentId);
          this.frmBaseline.get('assessmentDate').setValue(this.tutorReportsHelperService.baseline.assessmentCaptureDate);

          if (this.media.isActive('xs')) {
            this.setDropdownValues(this.keyStages, "initialKeyStage", false);
            this.setDropdownValues(this.grades, "initialLearningBand", true);

            this.setDropdownValues(this.keyStages, "targetKeyStage", false);
            this.setDropdownValues(this.grades, "targetLearningBand", true);
          }

          if (!this.tutorReportsHelperService.baseline.submitted && !this.tutorReportsHelperService.baseline.approved) {
            this.frmBaseline.enable();
          } else if (this.hasEditPermissions && !this.tutorReportsHelperService.baseline.approved) {
            this.frmBaseline.enable();
          } else {
            this.frmBaseline.disable();
          }

          this.statusUpdated.emit(this.tutorReportsHelperService.baseline.statusDescription);
          this.baselineStatus = this.tutorReportsHelperService.baseline.statusDescription;
          this.getHistoryData();
        }

      } catch (error) {
        let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
        if (errorMessage == "Object reference not set to an instance of an object.") {
          errorMessage = "Client not found. Try another."
        }
        this.errorModalHelper.show(errorMessage, error);
      }
    }

  }

  submitBaseline() {
    var formModel = this.populateModel();
    this.enableValidation = true;
    this.setValidators();
    if (this.frmBaseline.invalid) {
      this.errorModalHelper.show("Please complete all sections before submitting", { isValidationError: true });
      return;
    }
    formModel.statusId = 2;
    formModel.submitted = true;
    this.placementService.submitBaseline(formModel).subscribe(async data => {
      this.scrollBeforeClose();

      try {
        await this.refreshBaseline();
      } catch (error) {
        let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
        if (errorMessage == "Object reference not set to an instance of an object.") {
          errorMessage = "Client not found. Try another."
        }
        this.errorModalHelper.show(errorMessage, error);
      }

      setTimeout(() => {
        this.successModalHelper.show('Individual Learning Plan submitted');
        this.onDataSaved.emit(formModel.baselineDate);

        formModel.rowId = data;
        this.createAction(formModel, 3);
        this.deleteAction(formModel, 7);
        this.deleteAction(formModel, 9);

        this.close();
        this.ngOnInit();
      }, 500);
    },
      error => {
        this.errorModalHelper.show(error.message, error);
      })
  }

  setValidators() {
    this.frmBaseline.get('targetDescription').setValidators(null);
    this.frmBaseline.get('tutorInitialAssessment').setValidators(null);
    this.frmBaseline.get('assessmentScorePercentage').setValidators(null);

    if (this.enableValidation) {
      this.frmBaseline.get('targetDescription').setValidators([Validators.required, Validators.minLength(20), Validators.maxLength(1024)]);
      this.frmBaseline.get('tutorInitialAssessment').setValidators([Validators.required, Validators.minLength(20), Validators.maxLength(1024)]);
      this.frmBaseline.get('assessmentScorePercentage').setValidators([Validators.min(0), Validators.max(100)]);
    }

    this.frmBaseline.get('targetDescription').updateValueAndValidity();
    this.frmBaseline.get('tutorInitialAssessment').updateValueAndValidity();
    this.frmBaseline.get('assessmentScorePercentage').updateValueAndValidity();
    this.frmBaseline.updateValueAndValidity();
  }

  saveDraftbaseline() {
    this.enableValidation = false;
    this.setValidators();
    if (this.frmBaseline.invalid) {
      this.errorModalHelper.show("Please complete all sections before saving", { isValidationError: true });
      return;
    }
    var formModel = this.populateModel();
    formModel.statusId = 1;
    this.placementService.saveBaseline(formModel).subscribe(async data => {
      this.scrollBeforeClose();

      try {
        await this.refreshBaseline();
      } catch (error) {
        let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
        if (errorMessage == "Object reference not set to an instance of an object.") {
          errorMessage = "Client not found. Try another."
        }
        this.errorModalHelper.show(errorMessage, error);
      }

      setTimeout(() => {
        this.successModalHelper.show('Individual Learning Plan details saved');
        this.onDataSaved.emit(formModel.baselineDate);
        this.close();
        this.ngOnInit();
      }, 500);
    },
      error => {
        this.errorModalHelper.show(error.message, error);
      })
  }

  submitByAdmin() {
    this.submitBaseline();
  }

  populateModel() {
    let formModel = this.frmBaseline.value;
    formModel.placementId = this.tutorReportsHelperService.commonData.placementId;
    formModel.studentId = this.groupStudentId ? this.groupStudentId : this.studentIdForLinkAssessment;
    formModel.baselineDate = new Date(this.setDate(formModel.baselineDate));
    formModel.rowId = formModel.rowId == null ? 0 : formModel.rowId;
    formModel.applicationUserId = this.tutorReportsHelperService.commonData.applicationUserId;

    formModel.initialKeyStage = this.getFormValueForDropdowns(this.keyStages, "initialKeyStage", false);
    formModel.initialLearningBand = this.getFormValueForDropdowns(this.grades, "initialLearningBand", true);

    formModel.targetKeyStage = this.getFormValueForDropdowns(this.keyStages, "targetKeyStage", false);
    formModel.targetLearningBand = this.getFormValueForDropdowns(this.grades, "targetLearningBand", true);
    return formModel;
  }

  public approveData(event) {
    this.enableValidation = true;
    var formModel = this.populateModel();
    this.setValidators();
    if (this.frmBaseline.invalid) {
      this.errorModalHelper.show("Please complete all sections before approving", { isValidationError: true });
      return;
    }
    formModel.statusId = 3;
    if (formModel.rowId === 0) {
      this.errorModalHelper.show("Submit the page", { isValidationError: true });
    } else {
      this.placementService.ApproveBaseline(formModel).subscribe(async data => {
        this.scrollBeforeClose();

        try {
          await this.refreshBaseline();
        } catch (error) {
          let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
          if (errorMessage == "Object reference not set to an instance of an object.") {
            errorMessage = "Client not found. Try another."
          }
          this.errorModalHelper.show(errorMessage, error);
        }

        setTimeout(() => {
          this.successModalHelper.show("Individual Learning Plan is approved");
          this.deleteAction(formModel, 3);
          this.close();
          this.ngOnInit();
        }, 500);
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        })
    }
  }

  public rejectData(data) {
    var formModel = this.populateModel();
    formModel.statusId = 4;
    if (formModel.rowId === 0) {
      this.errorModalHelper.show("Submit the page", { isValidationError: true });
    } else {
      var rejectData = {
        rowId: formModel.rowId,
        comment: data
      };

      this.placementService.RejectBaseline(rejectData).subscribe(async data => {
        this.scrollBeforeClose();

        try {
          await this.refreshBaseline();
        } catch (error) {
          let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
          if (errorMessage == "Object reference not set to an instance of an object.") {
            errorMessage = "Client not found. Try another."
          }
          this.errorModalHelper.show(errorMessage, error);
        }

        setTimeout(() => {
          this.successModalHelper.show("Individual Learning Plan is rejected");
          //   this.deleteAction(formModel, 3);
          this.createAction(formModel, 7);
          this.close();
          this.ngOnInit();
        }, 500);
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        })
    }
  }

  public unlockBaseline(): void {
    let studentId = this.groupStudentId == undefined ? this.placementData.studentId : this.groupStudentId;
    this.placementService.unlockBaseline(this.tutorReportsHelperService.commonData.placementId, studentId).subscribe(async response => {
      this.successModalHelper.show("Successfully unlocked the session");

      try {
        await this.refreshBaseline();
      } catch (error) {
        let errorMessage = error.status === 401 ? "Unauthorized" : error.message;
        if (errorMessage == "Object reference not set to an instance of an object.") {
          errorMessage = "Client not found. Try another."
        }
        this.errorModalHelper.show(errorMessage, error);
      }

      this.renderComponent();
    }, error => {
      this.errorModalHelper.show(error.message, error);
    });
  }

  private deleteAction(model, actionType) {
    var actionData = {
      placementId: this.tutorReportsHelperService.commonData.placementId,
      actionTypeId: actionType,
      rowId: model.rowId,
      appUserId: this.tutorReportsHelperService.commonData.applicationUserId,
      id: this.tutorReportsHelperService.commonData.actionId,
      tutorId: this.placementData.tutorId,
      section: 'IP'
    };
    this.actionService.deleteAction(actionData).subscribe(action => {

    });
  }

  private createAction(model, actiontype) {
    var actionData = {
      placementId: this.tutorReportsHelperService.commonData.placementId,
      actionTypeId: actiontype,
      rowId: model.rowId,
      appUserId: this.tutorReportsHelperService.commonData.applicationUserId,
      tutorId: this.placementData.tutorId,
      section: 'IP'
    };
    this.actionService.createAction(actionData).subscribe(action => {

    });
  }

  setDate(date) {
    var d = new Date(date);
    return d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  }

  private openDialog() {
    const dialogRef = this.dialog.open(SubmissionHistoryRecords, {
      data: { rowId: this.frmBaseline.value.rowId, reportSection: 'IP' },
      panelClass: 'my-dialog'
      //data : this.submissionData
    });
  }

  private getHistoryData() {
    var subParam = { rowId: this.frmBaseline.value.rowId, reportSection: 'IP' };
    this.placementService.GetSubmissionHistory(subParam).subscribe(result => {
      this.submissionData = result;
    });
  }

  private openDropdownDialog(dataList, controlName, controlHeader, value, secondValue) {
    const dialogRef = this.dialog.open(DropdownDialogComponent, {
      panelClass: 'dropdown-dialog-container',
      data: { header: controlHeader, items: dataList, selected: value, secondValue: secondValue }
    });

    dialogRef.componentInstance.onValueSelected.subscribe((data) => {
      if (secondValue) {
        data = this.grades.find(x => x.description === data).code + "  " + data;
      }
      this.frmBaseline.get(controlName).setValue(data);
      dialogRef.close();
    })
  }

  loadContent(mQuery) {
    if (mQuery === 'xs') {
      this.setDropdownValues(this.keyStages, "initialKeyStage", false);
      this.setDropdownValues(this.grades, "initialLearningBand", true);

      this.setDropdownValues(this.keyStages, "targetKeyStage", false);
      this.setDropdownValues(this.grades, "targetLearningBand", true);
    }
    else {
      if (this.frmBaseline && this.frmBaseline.value) {
        var data = this.frmBaseline.value;
        this.setDropdownValuesforLargeDevices(this.grades, "initialLearningBand", true)
        this.setDropdownValuesforLargeDevices(this.keyStages, "initialKeyStage", false)

        this.setDropdownValuesforLargeDevices(this.grades, "targetLearningBand", true)
        this.setDropdownValuesforLargeDevices(this.keyStages, "targetKeyStage", false)
      }
    }
  }

  setDropdownValuesforLargeDevices(listData, controlName, secondValue) {
    var ctrlValue = this.frmBaseline.get(controlName).value;
    var value = ctrlValue;
    if (ctrlValue != null && isNaN(ctrlValue)) {
      if (secondValue) {
        value = listData.find(x => ctrlValue.includes(x.description)).id;
      }
      else {
        value = listData.find(x => x.description === ctrlValue).id;
      }
      if (value === -1) {
        this.frmBaseline.get(controlName).setValue(null);
      }
    }
    this.frmBaseline.get(controlName).setValue(value);
  }

  setDropdownValues(listData, controlName, secondValue) {
    var value = listData.find(x => x.id === this.frmBaseline.get(controlName).value);
    if (value != null && value.description !== null) {
      var strValue = secondValue ? value.code + "  " + value.description : value.description;
      this.frmBaseline.get(controlName).setValue(strValue);
    }
  }

  getFormValueForDropdowns(listData, controlName, secondValue) {
    var ctrlValue = this.frmBaseline.get(controlName).value;
    var value = ctrlValue;
    if (ctrlValue != null && isNaN(ctrlValue)) {
      if (secondValue) {
        value = listData.find(x => x.code + "  " + x.description === ctrlValue).id;
      }
      else {
        value = listData.find(x => x.description === ctrlValue).id;
      }
      if (value === -1) {
        this.frmBaseline.get(controlName).setValue(null);
        return null;
      }
    }
    else if (ctrlValue === -1) {
      return null;
    }

    return value;
  }

  public close() {
    this.onClosed.emit(true);
  }

  public openReferenceTable(): void {
    const dialogRef = this.dialog.open(LearningBandTableModalComponent,
      {
        panelClass: 'my-dialog'
      });
  }

  public parseAssessmentScore($e: any) {
    // This will prevent: "e", "=", ",", "+" "-", "-", "." // Covers minus on number pad also.
    // removed binding to - and .  109, 189, 190
    if ([69, 187, 188, 107].includes($e.keyCode)) {
      $e.preventDefault();
    }

    if (!/^[-+]?(\d+)?([.]?\d{0,1})?$/g.test($e.target.value)) {
      // block unless its the backspace
      if (![8].includes($e.keyCode)) {
        $e.preventDefault();
      }
    }
  }

  private scrollBeforeClose(): void {
    // window.scroll({ top: 0, behavior: 'smooth' });
    const element = document.getElementById("panel-group");
    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  private refreshBaseline(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.placementService.getBaseline(this.tutorReportsHelperService.commonData.placementId, this.groupStudentId, this.groupStudentId != null).subscribe((baseline: Baseline) => {
        this.tutorReportsHelperService.baseline = baseline;
        resolve("success");
      }, error => {
        reject(error);
      });
    });

  }

  private getBaseline(): Promise<Baseline> {
    return new Promise((resolve: any, reject: any) => {
      let studentId = this.groupStudentId == undefined ? this.placementData.studentId : this.groupStudentId;
      this.placementService.getBaseline(this.placementData.placementID, studentId, this.placementData.isGroup).subscribe((baseline: Baseline) => {
        resolve(baseline);
      }, error => {
        reject(error)
      });
    });
  }


}
